import { useDonationContextProvider } from 'context/DonationContextProvider';
import { Button } from 'react-bootstrap';

import { DonationHeader } from './DonationHeader';
import { DONATION_STEPS } from './data';

function DonationFailedPage() {
  const { setDonationStep } = useDonationContextProvider();

  return (
    <div>
      <DonationHeader />
      <div className="wr-donation-thanks-container">
        <div className="mx-auto mb-2 rounded-5 d-flex flex-column gap-25 wr-donation-thanks-card">
          <div className="text-center">
            <div className="mb-4">
              <i
                className="fas fa-times-circle text-danger"
                style={{ fontSize: '64px' }}
              />
            </div>

            <p
              className="font-patrick mb-2 text-danger"
              style={{ fontSize: '42px' }}
            >
              Payment Failed
            </p>

            <p className="fs-0 wr-donation-text-grey-900">
              We're sorry, but your payment could not be processed at this time.
              This could be due to insufficient funds, incorrect card details,
              or a temporary issue with your payment method.
            </p>
          </div>

          <div className="d-flex flex-column gap-3">
            <Button
              className="w-100 h-48 text-uppercase d-flex align-items-center justify-content-center gap-2 wr-donation-btn bg-wr-donation-primary"
              onClick={() => setDonationStep(DONATION_STEPS.BASKET_CREATION)}
            >
              Return to Donation Page
            </Button>
          </div>
        </div>
        {/* <PrivacyPolicy /> */}
      </div>
    </div>
  );
}

export { DonationFailedPage };
